import React, { useState } from "react";
import { FaExclamationTriangle, FaTrashAlt } from "react-icons/fa";
import axiosInstance from "../api/axiosInterceptor";
import SyncLoader from "./Loader";
import "../styles/DeleteUser.css";

const DeleteUser = () => {
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const normalizedEmail = email.trim().toLowerCase();
  const normalizedConfirmEmail = confirmEmail.trim().toLowerCase();
  const canDelete =
    normalizedEmail &&
    normalizedConfirmEmail &&
    normalizedEmail === normalizedConfirmEmail &&
    isConfirmed &&
    !isLoading;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    if (!normalizedEmail) {
      setErrorMessage("Please enter the user's email address.");
      return;
    }

    if (normalizedEmail !== normalizedConfirmEmail) {
      setErrorMessage("Confirmation email must match the user email.");
      return;
    }

    if (!isConfirmed) {
      setErrorMessage("Please confirm that you understand this is permanent.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await axiosInstance.delete("/admin/users/delete-test/", {
        data: { email: normalizedEmail },
      });

      setSuccessMessage(
        response?.data?.message ||
          response?.data?.detail ||
          `User ${normalizedEmail} has been permanently deleted.`
      );
      setEmail("");
      setConfirmEmail("");
      setIsConfirmed(false);
    } catch (error) {
      console.error("Permanent user delete failed:", error);
      setErrorMessage(
        error?.response?.data?.error ||
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "Failed to delete the user. Please verify the email and try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="delete-user-page">
      {isLoading && <SyncLoader message="Deleting user" />}

      <section className="delete-user-warning" role="alert">
        <FaExclamationTriangle className="delete-warning-icon" />
        <div>
          <h1>Permanent User Delete</h1>
          <p>
            Warning: this action permanently deletes the user from the database.
            It cannot be undone. Confirm the email carefully before submitting.
          </p>
        </div>
      </section>

      <form className="delete-user-form" onSubmit={handleSubmit}>
        <div className="delete-user-form-header">
          <h2>Delete User by Email</h2>
          <p>Use this page only after confirming the account must be removed forever.</p>
        </div>

        {successMessage && <div className="delete-user-message success">{successMessage}</div>}
        {errorMessage && <div className="delete-user-message error">{errorMessage}</div>}

        <label htmlFor="delete-user-email">User Email</label>
        <input
          id="delete-user-email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="user@example.com"
          autoComplete="off"
          required
        />

        <label htmlFor="delete-user-confirm-email">Confirm User Email</label>
        <input
          id="delete-user-confirm-email"
          type="email"
          value={confirmEmail}
          onChange={(event) => setConfirmEmail(event.target.value)}
          placeholder="Re-enter the same email"
          autoComplete="off"
          required
        />

        <label className="delete-user-checkbox">
          <input
            type="checkbox"
            checked={isConfirmed}
            onChange={(event) => setIsConfirmed(event.target.checked)}
          />
          <span>I understand this will permanently delete the user from the database.</span>
        </label>

        <button type="submit" className="delete-user-submit" disabled={!canDelete}>
          <FaTrashAlt />
          {isLoading ? "Deleting..." : "Delete Permanently"}
        </button>
      </form>
    </div>
  );
};

export default DeleteUser;
